import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { fmtDay } from './tenantTime';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// «Confirmar todos» de un día: primero cuenta (dry_run) y pide confirmación
export function ConfirmDayButton({ date, onDone }) {
    const [count, setCount] = useState(null);
    const ask = async () => {
        try { setCount((await axios.post(`${API}/flights-unconfirmed-crew/confirm-day`, { date, dry_run: true })).data); }
        catch (e) { toast.error(e.response?.data?.detail || 'No se pudo consultar'); }
    };
    const run = async () => {
        try {
            const r = await axios.post(`${API}/flights-unconfirmed-crew/confirm-day`, { date });
            toast.success(`Confirmados ${r.data.crew} tripulante(s) en ${r.data.flights} vuelo(s)`);
            onDone?.();
        } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo confirmar'); }
        setCount(null);
    };
    return (
        <>
            <Button size="sm" className="h-7" onClick={ask} data-testid={`confirm-day-${date}`}><CheckCheck className="w-3.5 h-3.5 mr-1" />Confirmar todos</Button>
            <AlertDialog open={!!count} onOpenChange={o => !o && setCount(null)}>
                <AlertDialogContent data-testid="confirm-day-dialog">
                    <AlertDialogHeader>
                        <AlertDialogTitle>Confirmar tripulación del {fmtDay(date)}</AlertDialogTitle>
                        <AlertDialogDescription data-testid="confirm-day-summary">
                            Se van a confirmar {count?.crew} tripulante(s) en {count?.flights} vuelo(s). Cada tripulante recibirá su aviso y verá el vuelo en «Mis vuelos».
                        </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                        <AlertDialogCancel data-testid="confirm-day-cancel">Cancelar</AlertDialogCancel>
                        <AlertDialogAction onClick={run} data-testid="confirm-day-ok">Confirmar</AlertDialogAction>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    );
}
